export * from './portalEnum'

export enum ECustomFieldType {
  TEXT = 'text',
  DATE = 'date',
  DATE_TIME_DATA = 'dateTimeData',
  SINGLE_SELECT = 'singleSelect',
  MULTI_SELECT = 'multiSelect',
  NUMBER = 'number',
  ESIGN = 'eSign',
  FILES = 'files',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
  LOCATION = 'location',
  REFERENCE = 'reference',
  GHG_EMISSION = 'ghgEmission',
  CALCULATION = 'calculation',
  WEIGHT_MEASUREMENT = 'weightMeasurement',
  ADJUSTMENT = 'adjustment',
  LIST_STRING = 'listString',
}

export const AVAILABLE_DELIMITERS = ['.', ';', ':', '::', '/', '-', '_', '!', 'space'] as const

export enum ECustomButtonFormBuilderType {
  BUTTON = 'el-button',
  RADIO = 'el-radio-group',
}

export const enum EDisplaySetting {
  VISIBLE = 'visible',
  VISIBLE_WHEN_LOGGED_IN = 'visibleWhenLoggedIn',
  HIDDEN = 'hidden',
  UNKNOWN = 'unknown',
}

export const enum ECustomFieldUnitPosition {
  DEFAULT = '',
  UNKNOWN = 'unknown',
  PREFIX = 'prefix',
  SUFFIX = 'suffix',
}

export enum EFileKind {
  IMAGE = 'image',
  UNKNOWN = 'unknown',
  BARCODE_SCAN_FRAME = 'barcodeScanFrame',
  PHOTO_ONLY = 'photoOnly',
}

export enum EUserType {
  ENTERPRISE = 'enterprise',
  CARRIER = 'carrier',
  CLIENT = 'client',
}

export enum EValidationType {
  digitOnly = 'digitOnly',
  digitDashOnly = 'digitDashOnly',
  digitUnderscoreOnly = 'digitUnderscoreOnly',
  letterOnly = 'letterOnly',
  letterDashOnly = 'letterDashOnly',
  letterUnderscoreOnly = 'letterUnderscoreOnly',
  letterDigitOnly = 'letterDigitOnly',
  letterDigitDashOnly = 'letterDigitDashOnly',
  letterDigitUnderscoreOnly = 'letterDigitUnderscoreOnly',
  none = 'none',
}

export enum EParseType {
  LENGTH = 'length',
  DELIMITER = 'delimiter',
  REGEX = 'regex',
}

export enum EActivatedDateOptions {
  Dynamic = 'dynamicDate',
  Static = 'staticDate',
}

export enum ValueDateOptions {
  Today = 'today',
  ThisWeek = 'thisWeek',
  ThisMonth = 'thisMonth',
  ThisYear = 'thisYear',
}
